import i18n from 'i18next';
import { checkServiceProvider } from './serviceProviderConfig';

export const columns = [
  {
    id: 'date',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.date'),
  },
  {
    id: 'driver',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('common.driver'),
  },
  {
    id: 'odometer',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('refillsHistory.odometer'),
  },
  {
    id: 'gallons',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('refillsHistory.fuelAmount'),
  },
  {
    id: 'cost',
    numeric: true,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('refillsHistory.cost'),
  },
  {
    id: 'jurisdictionLocation',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: checkServiceProvider('jurisdictionLocationLabel', window.$environment?.SERVICE_PROVIDER, false),
  },
  {
    id: 'receipt',
    numeric: false,
    disablePadding: false,
    needSorting: true,
    label: i18n.t('eld.receipts'),
  },
  {
    id: 'actions',
    label: i18n.t('Actions'),
  },
];
